export default function NewTempInfo(){
  return(
    <div>
      New Template Info coming soon!
    </div>
  );
}